import { gql } from 'graphql-tag';

export const PaymentsFragment = gql`
  fragment Payments on LocationType {
    payments {
      paymentToken
      paymentType
      paymentUrl
    }
  }
`;
